import React from 'react';
import Icon from '../../../components/AppIcon';

const AIInsightsPanel = ({ insights }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/20 rounded-lg shadow-md p-4 md:p-5 sticky top-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon name="Lightbulb" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          AI Insights
        </h3>
      </div>

      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-1">
            <Icon name="Sparkles" size={16} color="var(--color-accent)" />
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-2">
              Why This Plan Works For You
            </h4>
            <p className="text-sm text-muted-foreground whitespace-pre-wrap leading-relaxed">
              {insights}
            </p>
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-start gap-3 mb-3">
            <Icon name="Target" size={16} color="var(--color-success)" />
            <p className="text-xs text-muted-foreground">
              This meal plan is personalized based on your fitness goals, dietary preferences, and nutritional requirements.
            </p>
          </div>

          <div className="flex items-start gap-3 mb-3">
            <Icon name="TrendingUp" size={16} color="var(--color-primary)" />
            <p className="text-xs text-muted-foreground">
              The AI continuously learns from your feedback and progress to refine future recommendations.
            </p>
          </div>

          <div className="flex items-start gap-3">
            <Icon name="ShieldCheck" size={16} color="var(--color-accent)" />
            <p className="text-xs text-muted-foreground">
              All recommendations are based on evidence-based nutritional science and adapted to your individual needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIInsightsPanel;